import { Layout } from 'antd';
import * as React from 'react';
import { connect } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import AppConfig from '../../config/AppConfig';
import themes from '../../config/themes';
import AppRedux from '../../redux/app/appRedux';
import AppRouter from './AppRouter';
import AppHolder from './commonStyle';
import './global.css';
import SagaAuthRedux from '../../redux/sagaAuth/sagaAuthRedux';
import { isRenderAsIFrame } from '../../helpers/utility';

const { Content, Footer, Header } = Layout;

class App extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            loginResponse: null
        };
    }

    public componentDidMount() {
    }

    public componentWillReceiveProps(newProps) {
        const newState = {
            loginResponse: newProps.loginResponse
        };

        this.setState(newState);
    }

    public renderByCondition() {
        if (isRenderAsIFrame()) {
            // render without header, footer
            return this.renderContent();
        }
        else {
            // render with header, footer
            return this.renderWithHeaderAndFooter();
        }
    }

    public renderWithHeaderAndFooter() {
        return (
            <div>
                <Header className='iframe-header'>
                    <img src={require('../../image/saga_logo.png')} />
                </Header>
                {this.renderContent()}
                <Footer
                    style={{
                        background: '#ffffff',
                        textAlign: 'center',
                        borderTop: '1px solid #ededed'
                    }}>
                    {AppConfig.siteConfig.footerText}
                    <p />
                    <p>{`Version ${AppConfig.version}`}</p>
                </Footer>
            </div>
        );
    }

    public renderContent() {
        return <Content
            style={{
                // padding: '70px 0 0',
                flexShrink: 0,
                background: '#f1f3f6'
            }}>
            <AppRouter url={this.props.match.url} />
        </Content>;
    }

    public render() {
        const { url } = this.props.match;
        return (
            <ThemeProvider theme={themes[AppConfig.themeConfig.theme]}>
                <AppHolder>
                    {this.renderByCondition()}
                </AppHolder>
            </ThemeProvider>
        );
    }
}

const mapStateToProps = (state) => {
    return { loginResponse: state.SagaAuth.loginResponse };
};

const mapDispatchToProps = (dispatch) => {
    return {
        toggleAll: (width, height) => dispatch(AppRedux.toggleAll(width, height)),
        requestLogout: () => dispatch(SagaAuthRedux.requestLogout())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App/AppIFrame.tsx